<template>
  <div
    :class="`nrcard ${
      active ? 'nrcard-' + color : ''
    } ${setOpacity} ${setBoxShadow}`"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'NrCard',
  props: {
    hovered: {
      type: Boolean
    },
    faded: {
      type: Boolean,
      default: false
    },
    color: {
      type: String
    },
    active: {
      type: Boolean
    }
  },
  computed: {
    setBoxShadow() {
      return this.hovered ? 'on-hover' : 'no-hover'
    },
    setOpacity() {
      return this.faded ? 'with-fade' : 'no-fade'
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/globals.scss';
.nrcard {
  background: #f9f9fa;
  padding: 12px;
  top: 20px;
  margin: 10px 0px;
  font-size: 16px;
  .nr-card-tag {
    font-weight: bolder;
    font-size: 16px;
    padding: 8px;
    height: 24px;
    position: relative;
    top: -2px;
  }
  &.with-fade {
    opacity: 0.2;
  }
  &.no-fade {
    opacity: 1;
  }
  &.on-hover {
    box-shadow: 2px 4px 8px -2px #6e6e87;
  }
  &.no-hover {
    box-shadow: 2px 2px 3px -1px #bcbcbc;
  }
  &-type {
    font-size: 24px;
    line-height: 1.5;
  }
  .risk-tag {
    font-weight: bolder;
    font-size: 16px;
    padding: 8px;
    height: 24px;
    position: relative;
    top: -2px;
  }
  &-red {
    border: 1px solid $red;
  }
  &-yellow {
    border: 1px solid $yellow;
  }
  &-green {
    border: 1px solid $green;
  }
  &-grey {
    border: 1px solid $grey;
  }
  &-orange {
    border: 1px solid $orange;
  }
  &-turquoise {
    border: 1px solid $turquoise;
  }
  &-cyan {
    border: 1px solid $cyan;
  }
  &-blue {
    border: 1px solid $blue;
  }
  &-black {
    border: 1px solid $black;
  }
  &-purple {
    border: 1px solid $purple;
  }
}
</style>
